import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectsClientDahsboard, DeleteProject, setProjectPublicPrivate, setprojectStatus, getShowcaseOrderListing, GetFinancialDashBoard, CreateInvoice, GetInvoices, TransactionHistory, GetMileStons } from '../../Apis/index';

export const GetProjectsListing = createAsyncThunk('GetProjectsListing', async ({ formData, token }, { rejectWithValue }) => {
    try {

        const response = await getProjectsClientDahsboard(formData, token);
        console.log("show response---->", response.data);
        return response;


    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const RemoveProject = createAsyncThunk('RemoveProject', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await DeleteProject(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const MakePrivateProject = createAsyncThunk('MakePrivateProject', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await setProjectPublicPrivate(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const UpdateProjectStatus = createAsyncThunk('UpdateProjectStatus', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await setprojectStatus(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetShowListing = createAsyncThunk('GetShowListing', async ({ formData, token }, { rejectWithValue }) => {
    try {

        const response = await getShowcaseOrderListing(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const getFinancialDashBoard = createAsyncThunk("getFinanicalDashBoard", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await GetFinancialDashBoard(token, formData)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})
export const createInvoices = createAsyncThunk("createInvoice", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await CreateInvoice(token, formData)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const getInvoicesList = createAsyncThunk("getInvoiceList", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const respose = await GetInvoices(token, formData);
        return respose
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const getTransactionHistory = createAsyncThunk("getTransactionHistory", async ({ token, formData, page }, { rejectWithValue }) => {
    try {
        const response = await TransactionHistory(token, formData, page);
        return response
    } catch (error) {
        return rejectWithValue(error?.response?.data)
    }
})

export const getMileStones = createAsyncThunk("getMileStones", async ({ token, page }, { rejectWithValue }) => {
    try {
        const response = await GetMileStons(token, page);
        return response;
    } catch (error) {
        return rejectWithValue(error?.response?.data)
    }
})

const clientDashboardSlice = createSlice({
    name: 'clientDashboard',
    initialState: {
        error: null,
        success: false,
        success2: false,
        data: [],
        showcase: [],
        milestones: [],
        invoices: [],
        transactions: [],
        mileStones: []

    },
    reducers: {
        clearclientdashboardStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetProjectsListing.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetProjectsListing.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetProjectsListing.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(RemoveProject.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(RemoveProject.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(RemoveProject.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(MakePrivateProject.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(MakePrivateProject.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(MakePrivateProject.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetShowListing.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetShowListing.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.showcase = action.payload.data.freelancerdata;
            })
            .addCase(GetShowListing.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(getFinancialDashBoard.pending, state => {
                state.success = false;
                state.error = null;

            })
            .addCase(getFinancialDashBoard.fulfilled, (state, action) => {
                state.success = action.payload.data.success;
                state.error = null;
                state.data = action.payload.data.data.milestone
            })
            .addCase(getFinancialDashBoard.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;
            })
            .addCase(createInvoices.pending, state => {
                state.success2 = false;
                state.error = null;

            })
            .addCase(createInvoices.fulfilled, (state, action) => {
                state.success2 = true;
                state.error = null;

            })
            .addCase(createInvoices.rejected, (state, action) => {
                state.success2 = false;
                state.error = action.payload.data.message
            })
            .addCase(getInvoicesList.pending, state => {
                state.success = false;
                state.error = null
            })
            .addCase(getInvoicesList.fulfilled, (state, action) => {
                state.success = true;
                state.invoices = action.payload.data.data;
                state.error = null;

            })
            .addCase(getInvoicesList.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;
            })
            .addCase(getTransactionHistory.pending, state => {
                state.error = null;
                state.success = false;

            })
            .addCase(getTransactionHistory.fulfilled, (state, action) => {
                state.success = true;
                state.transactions = action.payload.data?.data
                state.error = null;
            })
            .addCase(getTransactionHistory.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false
            })
            .addCase(getMileStones.pending, state => {
                state.error = null;
                state.success = false
            })
            .addCase(getMileStones.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.mileStones = action.payload.data.data
            })
            .addCase(getMileStones.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;
            })
    },

});
export const { clearclientdashboardStatus } = clientDashboardSlice.actions;
export default clientDashboardSlice.reducer;

